import type { Theme } from '@mui/material/styles'
import { getNf } from './nfTokens'

export const nfMenuPaperSx = (theme: Theme) => {
  const t = getNf(theme)
  return {
    borderRadius: '10px',
    border: `1px solid ${t.line}`,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 14px 34px rgba(0,0,0,.45)'
        : '0 14px 34px rgba(17,25,39,.18)',
    mt: 0.5,
    // Même taille que le texte du champ (11.5) : sinon MenuItem (12) et les
    // messages vides/chargement de l'Autocomplete (body1) paraissent plus gros.
    '& .MuiMenuItem-root, & .MuiAutocomplete-option, & .MuiAutocomplete-noOptions, & .MuiAutocomplete-loading':
      { fontSize: 11.5 },
  }
}

// Liste de champs groupés (ajout d'un champ au modèle, recherche de /declaration) : sections en
// bandeau teinté qui reste en haut au défilement, options resserrées.
export const nfGroupedListboxSx = (theme: Theme) => {
  const nf = getNf(theme)
  return {
    py: 0,
    maxHeight: 320,
    '& .MuiAutocomplete-groupLabel': {
      top: 0,
      lineHeight: '26px',
      px: 1.5,
      bgcolor: nf.surfaceMuted,
      borderTop: `1px solid ${nf.line2}`,
      borderBottom: `1px solid ${nf.line2}`,
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      color: nf.muted,
    },
    '& .MuiAutocomplete-groupUl': { py: 0.5 },
    '& .MuiAutocomplete-option': {
      minHeight: 30,
      mx: 0.5,
      px: 1.25,
      py: 0,
      borderRadius: '6px',
      fontSize: 11.5,
      color: nf.ink,
      '&.Mui-focused': { bgcolor: nf.line2 },
      '&[aria-disabled="true"]': { opacity: 0.45 },
    },
  }
}

/**
 * Menus des Select du wizard : ouverts sous le champ, comme les Autocomplete,
 * au lieu de recouvrir le champ (placement par défaut de MUI sur l'option choisie).
 * Hauteur plafonnée : un menu plus haut que la place sous le champ est remonté
 * par le Popover pour rester à l'écran, et recouvre alors le champ.
 */
export const nfSelectMenuProps = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
  PaperProps: {
    sx: (theme: Theme) => ({ ...nfMenuPaperSx(theme), maxHeight: 280 }),
  },
} as const
